import {
  validEmail,
  validPassword,
  validUserName,
  successRes,
  errorRes,
  sleep,
} from "../../utils.js";
import { handleSignOut } from "../gapi";

export const signUpUser = async (userName, email, password, userType, self) => {
  if (!validEmail(email)) {
    self.setLoginErrMsg("Email is not valid");
    return;
  }
  if (!validUserName(userName)) {
    self.setLoginErrMsg(
      "Username should only contain 8-16 alphanumeric characters"
    );
    return;
  }
  if (!validPassword(password)) {
    self.setLoginErrMsg(
      "Password should only contain 8-16 alphanumeric characters"
    );
    return;
  }
  try {
    const response = await fetch(self.host + "/signUp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userName, email, password, userType }),
      credentials: "include",
    });
    if (response.status !== 200) {
      return errorRes(
        "Looks like there was a problem. Status Code: " + response.status
      );
    }
    const res = await response.json();
    if (!res.error) {
      self.setState((state) => ({
        ...state,
        userId: res.data._id,
        userInfo: res.data,
      }));
      return successRes();
    } else {
      self.setState((state) => ({
        ...state,
        errMsgs: {
          ...state.errMsgs,
          login: res.errMsg,
        },
      }));
      return errorRes(res.errMsg);
    }
  } catch (err) {
    return errorRes("Fetch Error", err);
  }
};

export const signOutUser = async (self) => {
  handleSignOut();
  try {
    const response = await fetch(self.host + "/signOut", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    if (response.status !== 200) {
      return errorRes(
        "Looks like there was a problem. Status Code: " + response.status
      );
    }
    const res = await response.json();
    if (!res.error) {
      self.setState((state) => ({
        ...state,
        userId: null,
        userInfo: {},
      }));
      return successRes();
    } else {
      self.setLoginErrMsg(res.errMsg);
      return errorRes(res.errMsg);
    }
  } catch (err) {
    console.log(err);
    self.setState((state) => ({
      ...state,
      localMode: false,
      userId: null,
    }));
    return errorRes("Fetch Error", err);
  }
};

export const signInUser = async (email, password, initial = false, self) => {
  if (!initial) {
    if (!validEmail(email)) {
      self.setLoginErrMsg("Email is not valid");
      return;
    }
    if (!validPassword(password)) {
      self.setLoginErrMsg(
        "Password should only contain 8-16 alphanumeric characters"
      );
      return;
    }
  }
  try {
    const response = await fetch(self.host + "/signIn", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
      credentials: "include",
    });
    if (response.status !== 200) {
      console.log(
        "Looks like there was a problem. Status Code: " + response.status
      );
      return;
    }
    const res = await response.json();
    if (!res.error) {
      self.setState((state) => ({
        ...state,
        userId: res.data._id,
        userInfo: res.data,
      }));
      await sleep(2000);
      self.setLoading(false);
      return successRes();
    } else {
      if (!initial) self.setLoginErrMsg(res.errMsg);
      else self.setLoading(false);
      return errorRes(res.errMsg);
    }
  } catch (err) {
    console.log(err);
    self.setLoading(false);
    window.alert("Server not reachable, switching to local mode");
    window.alert("You data might not be persistent in local mode");
    self.setState((state) => ({
      ...state,
      localMode: true,
    }));
    return errorRes("Fetch Error", err);
  }
};
